import {
  ChangeDetectorRef,
  Directive,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  type ChartTypeRegistry,
  type LegendItem,
  type LegendOptions,
  type Plugin,
} from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

import { type ChartType } from '../enums';

@Directive()
export abstract class LegendBase<T extends keyof ChartTypeRegistry> {
  protected readonly _changeDetectionRef = inject(ChangeDetectorRef);

  @Input()
  public displayLegend = true;

  @Input()
  public canToggleDataVisibility = true;

  /**
   * @ignore
   */
  protected _legendItems: LegendItem[];

  /**
   * @ignore
   */
  @ViewChild(BaseChartDirective, { static: false })
  protected _chartDirective: BaseChartDirective<ChartType>;

  /**
   * @ignore
   */
  protected get plugins(): Plugin<T>[] {
    return this._plugins;
  }

  /**
   * @ignore
   */
  private _plugins: Plugin<T>[] = [
    {
      id: 'legendRefreshPlugin',
      afterUpdate: () => this._getItems(),
      afterRender: () => this._getItems(),
    },
  ];

  /**
   * @ignore
   */
  protected _addPlugin(plugin: Plugin<T>): void {
    this._plugins = [...this._plugins, plugin];
  }

  /**
   * @ignore
   */
  private _getItems(): void {
    if (!this._chartDirective?.chart) {
      return;
    }

    this._legendItems = (
      this._chartDirective.chart.options.plugins.legend as LegendOptions<T>
    ).labels.generateLabels(this._chartDirective.chart);

    this._changeDetectionRef.detectChanges();
  }
}
